import React from 'react';
import PropTypes from 'prop-types';
import { Team, TeamNameDisplay, TeamName, GameTimeLayer, TeamRecord, TeamScore } from '../GameContext.style';
import TeamLogo from '@mlb/react-patterns/v4/components/TeamLogo/teamLogo';
import { TeamLogoTypes } from '@mlb/react-patterns/v4/components/TeamLogo/teamLogo.types';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import { format, utcToZonedTime } from 'date-fns-tz';
import es from 'date-fns/locale/es';
import GameStateBadgeDataContainer from '../../GameStateBadge/containers/GameStateBadgeDataContainer';

const dateFormat = 'E M/dd'; // Fri 9.27

const formatGameTime = (gameTimeString, isSpanish, TBD, translate, timezone) => {
    const options = isSpanish ? { locale: es } : undefined;
    const date = format(utcToZonedTime(gameTimeString, timezone), dateFormat, options);
    const time = TBD ? translate('label_tbd', 'TBD') : format(utcToZonedTime(gameTimeString, timezone), 'h:mm a zzz', { timeZone: timezone });
    return {
        date,
        time
    };
};

const formatRecordLabel = ({ wins, losses }) => wins + ' - ' + losses;

export const TeamMatchupLayer = ({
    gameState,
    gameTime,
    inningState,
    teams,
    language,
    startTimeTBD,
    timezone
}) => {
    const translate = useTranslate();

    const isSpanish = language === 'es';
    const { date, time } = formatGameTime(gameTime, isSpanish, startTimeTBD, translate, timezone);

    const { inningHalf, currentInning } = inningState;
    const showInning = currentInning && inningHalf;
    let inningHalfKey = `game_status_${inningHalf?.toLowerCase()}`;
    if (inningHalf === 'Bottom') {
        inningHalfKey = 'game_status_bottom_abbrev';
    } else if (inningState === 'Middle') {
        inningHalfKey = 'game_status_mid_abbrev';
    }
    const inningHalfText = translate(inningHalfKey, inningHalf);
    const inningStateLabel = inningHalfText + ' ' + currentInning;

    const { home, away } = teams;

    const homeExtraInfo = gameState === 'F' || gameState === 'L' ? <TeamRecord>{formatRecordLabel(home.record)}</TeamRecord> : null;
    const awayExtraInfo = gameState === 'F' || gameState === 'L' ? <TeamRecord>{formatRecordLabel(away.record)}</TeamRecord> : null;

    return (
        <>
            {gameState === 'P'
                ? <GameTimeLayer>
                    <span>{date}</span>
                    <span>{time}</span>
                </GameTimeLayer>
                : gameState === 'L'
                    ? <GameTimeLayer>
                        {showInning && <span>
                            {inningStateLabel}
                        </span>}
                    </GameTimeLayer>
                    : <GameTimeLayer>
                        <span>{date}</span>
                        <GameStateBadgeDataContainer />
                    </GameTimeLayer>
            }
            <Team displayExtraInfo={!!awayExtraInfo}>
                <TeamNameDisplay >
                    <TeamLogo
                        teamId={away.id}
                        teamLogoType={TeamLogoTypes.SPOT}
                        width={44}
                    />
                    <TeamName>
                        <div>{away.teamName}</div>
                        {awayExtraInfo}
                    </TeamName>

                </TeamNameDisplay >
                {gameState === 'P'
                    ? <TeamRecord>{formatRecordLabel(away.record)}</TeamRecord>
                    : <TeamScore>{away.runs}</TeamScore> }
            </Team>
            <Team displayExtraInfo={!!homeExtraInfo}>
                <TeamNameDisplay displayExtraInfo={!!homeExtraInfo}>
                    <TeamLogo
                        teamId={home.id}
                        teamLogoType={TeamLogoTypes.SPOT}
                        width={44}
                    />
                    <TeamName>
                        <div>{home.teamName}</div>
                        {homeExtraInfo}
                    </TeamName>
                </TeamNameDisplay>
                {gameState === 'P'
                    ? <TeamRecord>{formatRecordLabel(home.record)}</TeamRecord>
                    : <TeamScore>{home.runs}</TeamScore> }
            </Team>
        </>
    );
};

TeamMatchupLayer.propTypes = {
    gameState: PropTypes.string,
    gameTime: PropTypes.string,
    inningState: PropTypes.object,
    teams: PropTypes.object,
    language: PropTypes.string,
    startTimeTBD: PropTypes.bool,
    timezone: PropTypes.string
};
